module.exports = __webpack_public_path__ + "img/997b9b3.webp";